
//*****************************************************
// <auto-generated>
//   Generated by the cybtans protocol buffer compiler.  DO NOT EDIT!
//   Powered By Cybtans    
// </auto-generated>
//******************************************************

import { 
  AlbumDto,
  UpdateRequest,
  ListAlbumRequest,
  ListAlbumReply,
  AlbumRequest,
  AlbumByNameRequest,
  MediaDto,
  ShareAlbumRequest,
  ListMediaRequest,
  ListMediaReply,
  MediaRequest,
  UploadContentRequest,
  ContentRequest,
  ContentReply,
  TokenRequest,
  TokenReply,
  JwtkSetResponse,
  AuthCodeRequest,
  AuthCodeResponse,
  DeviceTokenResponse,
  AuthorizeDeviceCodeRequest,
  UserDto,
  RegisterRequest,
  UpdateUserRequest,
  ListTenantUserRequest,
  TenantUserResponse,
  InviteUserRequest,
  TenantDto,
  ListTenantsRequest,
  UserTenantListDto,
  CreateTenantRequest,
  UpdateTenantRequest,
  TenantRequest,
 } from './models';

export type Fetch = (input: RequestInfo, init?: RequestInit)=> Promise<Response>;
export type ErrorInfo = {status:number, statusText:string, text: string };

export interface MemogramOptions{
    baseUrl:string;
}

class BaseMemogramService {
    protected _options:MemogramOptions;
    protected _fetch:Fetch;    

    constructor(fetch:Fetch, options:MemogramOptions){
        this._fetch = fetch;
        this._options = options;
    }

    protected getQueryString(data:any): string|undefined {
        if(!data)
            return '';
        let args = [];
        for (let key in data) {
            if (data.hasOwnProperty(key)) {                
                let element = data[key];
                if(element !== undefined && element !== null && element !== ''){
                    if(element instanceof Array){
                        element.forEach(e=> args.push(key + '=' + encodeURIComponent(e instanceof Date ? e.toJSON(): e)));
                    }else if(element instanceof Date){
                        args.push(key + '=' + encodeURIComponent(element.toJSON()));
                    }else{
                        args.push(key + '=' + encodeURIComponent(element));
                    }
                }
            }
        }

       return args.length > 0 ? '?' + args.join('&') : '';    
    }

    protected getFormData(data:any): FormData {
        let form = new FormData();
        if(!data)
            return form;
        
        for (let key in data) {
            if (data.hasOwnProperty(key)) {                
                let value = data[key];
                if(value !== undefined && value !== null && value !== ''){
                    if (value instanceof Date){
                        form.append(key, value.toJSON());
                    }else if(typeof value === 'number' || typeof value === 'bigint' || typeof value === 'boolean'){
                        form.append(key, value.toString());
                    }else if(value instanceof File){
                        form.append(key, value, value.name);
                    }else if(value instanceof Blob){
                        form.append(key, value, 'blob');
                    }else if(typeof value ==='string'){
                        form.append(key, value);
                    }else{
                        throw new Error(`value of ${key} is not supported for multipart/form-data upload`);
                    }
                }
            }
        }
        return form;
    }

    protected getObject<T>(response:Response): Promise<T>{
        let status = response.status;
        if(status >= 200 && status < 300 ){            
            return response.json();
        }     
        return response.text().then((text) => Promise.reject<T>({  status, statusText:response.statusText, text }));        
    }

    protected getBlob(response:Response): Promise<Response>{
        let status = response.status;        

        if(status >= 200 && status < 300 ){             
            return Promise.resolve(response);
        }
        return response.text().then((text) => Promise.reject<Response>({  status, statusText:response.statusText, text }));
    }

    protected ensureSuccess(response:Response): Promise<ErrorInfo|void>{
        let status = response.status;
        if(status < 200 || status >= 300){
            return response.text().then((text) => Promise.reject<ErrorInfo>({  status, statusText:response.statusText, text }));        
        }
        return Promise.resolve();
    }
}

export class AlbumsService extends BaseMemogramService {  

    constructor(fetch:Fetch, options:MemogramOptions){
        super(fetch, options);        
    }
    
    create(request:AlbumDto) : Promise<AlbumDto> {
    	let options:RequestInit = { method: 'POST', headers: { Accept: 'application/json', Authorization: 'Bearer', 'Content-Type': 'application/json' }};
    	options.body = JSON.stringify(request);
    	let endpoint = this._options.baseUrl+`/api/v1/album`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    update(request:UpdateRequest) : Promise<AlbumDto> {
    	let options:RequestInit = { method: 'PUT', headers: { Accept: 'application/json', Authorization: 'Bearer', 'Content-Type': 'application/json' }};
    	options.body = JSON.stringify(request);
    	let endpoint = this._options.baseUrl+`/api/v1/album`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    list(request:ListAlbumRequest) : Promise<ListAlbumReply> {
    	let options:RequestInit = { method: 'GET', headers: { Accept: 'application/json', Authorization: 'Bearer' }};
    	let endpoint = this._options.baseUrl+`/api/v1/album`+this.getQueryString(request);
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    get(request:AlbumRequest) : Promise<AlbumDto> {
    	let options:RequestInit = { method: 'GET', headers: { Accept: 'application/json', Authorization: 'Bearer' }};
    	let endpoint = this._options.baseUrl+`/api/v1/album/${request.id}`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    getByName(request:AlbumByNameRequest) : Promise<AlbumDto> {
    	let options:RequestInit = { method: 'GET', headers: { Accept: 'application/json', Authorization: 'Bearer' }};
    	let endpoint = this._options.baseUrl+`/api/v1/album/name`+this.getQueryString(request);
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    delete(request:AlbumRequest) : Promise<ErrorInfo|void> {
    	let options:RequestInit = { method: 'DELETE', headers: { Accept: 'application/json', Authorization: 'Bearer' }};
    	let endpoint = this._options.baseUrl+`/api/v1/album`+this.getQueryString(request);
    	return this._fetch(endpoint, options).then((response:Response) => this.ensureSuccess(response));
    }
    
    updateCover(request:AlbumRequest) : Promise<MediaDto> {
    	let options:RequestInit = { method: 'PUT', headers: { Accept: 'application/json', Authorization: 'Bearer', 'Content-Type': 'application/json' }};
    	options.body = JSON.stringify(request);
    	let endpoint = this._options.baseUrl+`/api/v1/album/cover`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    shareAlbum(request:ShareAlbumRequest) : Promise<ErrorInfo|void> {
    	let options:RequestInit = { method: 'POST', headers: { Accept: 'application/json', Authorization: 'Bearer', 'Content-Type': 'application/json' }};
    	options.body = JSON.stringify(request);
    	let endpoint = this._options.baseUrl+`/api/v1/album/share`;
    	return this._fetch(endpoint, options).then((response:Response) => this.ensureSuccess(response));
    }
    
    getSharedAlbums(request:ListAlbumRequest) : Promise<ListAlbumReply> {
    	let options:RequestInit = { method: 'GET', headers: { Accept: 'application/json', Authorization: 'Bearer' }};
    	let endpoint = this._options.baseUrl+`/api/v1/album/shared`+this.getQueryString(request);
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }

}


export class MediaService extends BaseMemogramService {  

    constructor(fetch:Fetch, options:MemogramOptions){
        super(fetch, options);        
    }
    
    create(request:MediaDto) : Promise<MediaDto> {
    	let options:RequestInit = { method: 'POST', headers: { Accept: 'application/json', Authorization: 'Bearer', 'Content-Type': 'application/json' }};
    	options.body = JSON.stringify(request);
    	let endpoint = this._options.baseUrl+`/api/v1/media`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    update(request:UpdateRequest) : Promise<MediaDto> {
    	let options:RequestInit = { method: 'PUT', headers: { Accept: 'application/json', Authorization: 'Bearer', 'Content-Type': 'application/json' }};
    	options.body = JSON.stringify(request);
    	let endpoint = this._options.baseUrl+`/api/v1/media`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    list(request:ListMediaRequest) : Promise<ListMediaReply> {
    	let options:RequestInit = { method: 'GET', headers: { Accept: 'application/json', Authorization: 'Bearer' }};
    	let endpoint = this._options.baseUrl+`/api/v1/media`+this.getQueryString(request);
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    get(request:MediaRequest) : Promise<MediaDto> {
    	let options:RequestInit = { method: 'GET', headers: { Accept: 'application/json', Authorization: 'Bearer' }};
    	let endpoint = this._options.baseUrl+`/api/v1/media/${request.id}`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    delete(request:MediaRequest) : Promise<ErrorInfo|void> {
    	let options:RequestInit = { method: 'DELETE', headers: { Accept: 'application/json', Authorization: 'Bearer' }};
    	let endpoint = this._options.baseUrl+`/api/v1/media/${request.id}`;
    	return this._fetch(endpoint, options).then((response:Response) => this.ensureSuccess(response));
    }
    
    uploadContent(request:UploadContentRequest) : Promise<MediaDto> {
    	let options:RequestInit = { method: 'PUT', headers: { Accept: 'application/json', Authorization: 'Bearer' }};
    	options.body = this.getFormData(request);
    	let endpoint = this._options.baseUrl+`/api/v1/media/${request.id}/content`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    getContent(request:ContentRequest) : Promise<Response> {
    	let options:RequestInit = { method: 'GET', headers: { Authorization: 'Bearer' }};
    	let endpoint = this._options.baseUrl+`/api/v1/media/${request.id}/content`+this.getQueryString({ lodLevel: request.lodLevel});
    	return this._fetch(endpoint, options).then((response:Response) => this.getBlob(response));
    }
    
    getPoster(request:ContentRequest) : Promise<Response> {
    	let options:RequestInit = { method: 'GET', headers: { Authorization: 'Bearer' }};
    	let endpoint = this._options.baseUrl+`/api/v1/media/${request.id}/content/poster`+this.getQueryString({ lodLevel: request.lodLevel});
    	return this._fetch(endpoint, options).then((response:Response) => this.getBlob(response));
    }
    
    getDashManifest(request:MediaRequest) : Promise<Response> {
    	let options:RequestInit = { method: 'GET', headers: { Authorization: 'Bearer' }};
    	let endpoint = this._options.baseUrl+`/api/v1/media/${request.id}/mpd`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getBlob(response));
    }

}


/** Auth */
export class AuthService extends BaseMemogramService {  

    constructor(fetch:Fetch, options:MemogramOptions){
        super(fetch, options);        
    }
    
    /** Returns an Access Token */
    getToken(request:TokenRequest) : Promise<TokenReply> {
    	let options:RequestInit = { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }};
    	options.body = JSON.stringify(request);
    	let endpoint = this._options.baseUrl+`/api/Auth/token`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    /** Returns a Json Web Key Set */
    getJwtkSet() : Promise<JwtkSetResponse> {
    	let options:RequestInit = { method: 'GET', headers: { Accept: 'application/json' }};
    	let endpoint = this._options.baseUrl+`/api/Auth/jwtks`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    /** Returns an Auth Code */
    getAuthCode(request:AuthCodeRequest) : Promise<AuthCodeResponse> {
    	let options:RequestInit = { method: 'POST', headers: { Accept: 'application/json', Authorization: 'Bearer', 'Content-Type': 'application/json' }};
    	options.body = JSON.stringify(request);
    	let endpoint = this._options.baseUrl+`/api/Auth/code`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    /** Returns a Device Code */
    createDeviceCode() : Promise<DeviceTokenResponse> {
    	let options:RequestInit = { method: 'GET', headers: { Accept: 'application/json' }};
    	let endpoint = this._options.baseUrl+`/api/Auth/device`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    authorizeDevice(request:AuthorizeDeviceCodeRequest) : Promise<TokenReply> {
    	let options:RequestInit = { method: 'POST', headers: { Accept: 'application/json', Authorization: 'Bearer', 'Content-Type': 'application/json' }};
    	options.body = JSON.stringify(request);
    	let endpoint = this._options.baseUrl+`/api/Auth/device/auth`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    getTokenFromDeviceCode(request:AuthorizeDeviceCodeRequest) : Promise<TokenReply> {
    	let options:RequestInit = { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }};
    	options.body = JSON.stringify(request);
    	let endpoint = this._options.baseUrl+`/api/Auth/device/token`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }

}


/** Users */
export class UserService extends BaseMemogramService {  

    constructor(fetch:Fetch, options:MemogramOptions){
        super(fetch, options);        
    }
    
    getSessionUser() : Promise<UserDto> {
    	let options:RequestInit = { method: 'GET', headers: { Accept: 'application/json', Authorization: 'Bearer' }};
    	let endpoint = this._options.baseUrl+`/api/users`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    /** Register a new user */
    register(request:RegisterRequest) : Promise<UserDto> {
    	let options:RequestInit = { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }};
    	options.body = JSON.stringify(request);
    	let endpoint = this._options.baseUrl+`/api/users/register`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    update(request:UpdateUserRequest) : Promise<UserDto> {
    	let options:RequestInit = { method: 'PUT', headers: { Accept: 'application/json', Authorization: 'Bearer', 'Content-Type': 'application/json' }};
    	options.body = JSON.stringify(request);
    	let endpoint = this._options.baseUrl+`/api/users`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    listTenantUsers(request:ListTenantUserRequest) : Promise<TenantUserResponse> {
    	let options:RequestInit = { method: 'GET', headers: { Accept: 'application/json', Authorization: 'Bearer' }};
    	let endpoint = this._options.baseUrl+`/api/users/tenant`+this.getQueryString(request);
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    inviteUser(request:InviteUserRequest) : Promise<ErrorInfo|void> {
    	let options:RequestInit = { method: 'POST', headers: { Accept: 'application/json', Authorization: 'Bearer', 'Content-Type': 'application/json' }};
    	options.body = JSON.stringify(request);
    	let endpoint = this._options.baseUrl+`/api/users`;
    	return this._fetch(endpoint, options).then((response:Response) => this.ensureSuccess(response));
    }

}


/** Tenants */
export class TenantService extends BaseMemogramService {  

    constructor(fetch:Fetch, options:MemogramOptions){
        super(fetch, options);        
    }
    
    getSessionTenant() : Promise<TenantDto> {
    	let options:RequestInit = { method: 'GET', headers: { Accept: 'application/json', Authorization: 'Bearer' }};
    	let endpoint = this._options.baseUrl+`/api/tenants`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    getUserTenants(request:ListTenantsRequest) : Promise<UserTenantListDto> {
    	let options:RequestInit = { method: 'GET', headers: { Accept: 'application/json', Authorization: 'Bearer' }};
    	let endpoint = this._options.baseUrl+`/api/tenants/list`+this.getQueryString(request);
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    /** Register a new user */
    create(request:CreateTenantRequest) : Promise<TenantDto> {
    	let options:RequestInit = { method: 'POST', headers: { Accept: 'application/json', Authorization: 'Bearer', 'Content-Type': 'application/json' }};
    	options.body = JSON.stringify(request);
    	let endpoint = this._options.baseUrl+`/api/tenants`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    update(request:UpdateTenantRequest) : Promise<TenantDto> {
    	let options:RequestInit = { method: 'PUT', headers: { Accept: 'application/json', Authorization: 'Bearer', 'Content-Type': 'application/json' }};
    	options.body = JSON.stringify(request);
    	let endpoint = this._options.baseUrl+`/api/tenants`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }
    
    delete(request:TenantRequest) : Promise<ErrorInfo|void> {
    	let options:RequestInit = { method: 'DELETE', headers: { Accept: 'application/json', Authorization: 'Bearer' }};
    	let endpoint = this._options.baseUrl+`/api/tenants/${request.id}`;
    	return this._fetch(endpoint, options).then((response:Response) => this.ensureSuccess(response));
    }
    
    setSessionTenant(request:TenantRequest) : Promise<TenantDto> {
    	let options:RequestInit = { method: 'POST', headers: { Accept: 'application/json', Authorization: 'Bearer', 'Content-Type': 'application/json' }};
    	options.body = JSON.stringify(request);
    	let endpoint = this._options.baseUrl+`/api/tenants/select`;
    	return this._fetch(endpoint, options).then((response:Response) => this.getObject(response));
    }

}
